/* @flow */
// typecheck: ignore file
import React from 'react';
import type { Column } from 'components/SmartTable.jsx';
import Radio from 'components/Radio.jsx';
import { setSort } from 'reducers/tables';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import invariant from 'invariant';

import Spacing from 'styles/Spacing.css';

type Props = {
  column: Column,
  namespace: string,
  selectedSort: string,
  setSort: (namespace: string, sortKey: string) => any,
};

class SmartTableHeaderSorts extends React.Component {
  props: Props;

  setColumnSort = (sortKey: string) => {
    this.props.setSort(this.props.namespace, sortKey);
  }

  render() {
    invariant(this.props.column.sorts, 'column must have sorts');

    const radios = this.props.column.sorts.map(sort => {
      const radio = (
        <Radio
          name="sort"
          key={sort.key}
          label={sort.name}
          onChange={() => this.setColumnSort(sort.key)}
          checked={this.props.selectedSort === sort.key}
        />
      );
      if (sort.lastInSection) {
        return <div className={Spacing.marginBottomLarge}>{radio}</div>;
      } else {
        return radio;
      }
    });

    return (
      <div>
        <div className={Spacing.marginBottomLarge}>
          Sort by
        </div>
        {radios}
      </div>
    );
  }
}

// $FlowFixMe
function mapStateToProps(state: Object, props: Props) {
  return {
    selectedSort: state.tables.get(props.namespace).sort,
  };
}

function mapDispatchToProps(dispatch: Function) {
  // $FlowFixMe
  return bindActionCreators({ setSort }, dispatch);
}

export { SmartTableHeaderSorts };
export default connect(mapStateToProps, mapDispatchToProps)(SmartTableHeaderSorts);



// WEBPACK FOOTER //
// ./src/components/SmartTableHeaderSorts.jsx